"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = InputPhoneWithCountry;
var _slicedToArray2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = require("react");
var _excluded = ["defaultValue", "onChange", "required"];
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/InputPhone/index.js";
// Sample country code list (you can expand this)
var countryCodes = [{
  name: "Philippines",
  code: "+63",
  iso2: "PH",
  flag: "🇵🇭"
}, {
  name: "United States",
  code: "+1",
  iso2: "US",
  flag: "🇺🇸"
}, {
  name: "United Kingdom",
  code: "+44",
  iso2: "GB",
  flag: "🇬🇧"
}, {
  name: "India",
  code: "+91",
  iso2: "IN",
  flag: "🇮🇳"
}, {
  name: "Japan",
  code: "+81",
  iso2: "JP",
  flag: "🇯🇵"
}, {
  name: "China",
  code: "+86",
  iso2: "CN",
  flag: "🇨🇳"
}, {
  name: "Germany",
  code: "+49",
  iso2: "DE",
  flag: "🇩🇪"
}, {
  name: "France",
  code: "+33",
  iso2: "FR",
  flag: "🇫🇷"
}, {
  name: "Canada",
  code: "+1",
  iso2: "CA",
  flag: "🇨🇦"
}, {
  name: "Australia",
  code: "+61",
  iso2: "AU",
  flag: "🇦🇺"
}];
function InputPhoneWithCountry(_ref) {
  var _this = this;
  var _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue,
    onChange = _ref.onChange,
    required = _ref.required,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)("+63"),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    prefix = _useState2[0],
    setPrefix = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    number = _useState4[0],
    setNumber = _useState4[1];

  // Match prefix from defaultValue
  (0, _react.useEffect)(function () {
    var match = countryCodes.find(function (c) {
      return defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.startsWith(c.code);
    });
    if (match) {
      setPrefix(match.code);
      setNumber(defaultValue.slice(match.code.length));
    } else {
      setNumber(defaultValue);
    }
  }, [defaultValue]);
  var handlePrefixChange = function handlePrefixChange(e) {
    var newPrefix = e.target.value;
    setPrefix(newPrefix);
    onChange === null || onChange === void 0 ? void 0 : onChange("".concat(newPrefix).concat(number));
  };
  var handleNumberChange = function handleNumberChange(e) {
    var raw = e.target.value.replace(/\D/g, "").slice(0, 15); // max 15 digits
    setNumber(raw);
    onChange === null || onChange === void 0 ? void 0 : onChange("".concat(prefix).concat(raw));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "input-group",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("select", {
    className: "form-select",
    value: prefix,
    onChange: handlePrefixChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  }, countryCodes.map(function (c) {
    return /*#__PURE__*/React.createElement("option", {
      key: c.code + c.iso2,
      value: c.code,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 11
      }
    }, c.flag, " ", c.iso2, " (", c.code, ")");
  })), /*#__PURE__*/React.createElement("input", Object.assign({
    type: "text",
    className: "form-control",
    value: number,
    onChange: handleNumberChange,
    required: required,
    placeholder: "Enter phone number"
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 7
    }
  })));
}